import { axios }            from '../../../utils/axios';
import { observer, inject } from 'mobx-react';

import { Link }             from 'react-router-dom';
import React, { Component } from 'react';

import './Passport.css';

class Forgot extends Component<any, any> {
  constructor(props: any){
    super(props);

    this.state = {
      emailError: "",
      returnedError: "",
      returnedSuccess: "",
    }

    this.doForgotPassword            = this.doForgotPassword.bind(this);
  }

  doForgotPassword = (ev: React.FormEvent<HTMLFormElement>) => {
    var component: any = this;
    ev.preventDefault();

    component.setState({
      loading: true,
      emailError: "",
      returnedError: ""
    });

    this.props.rootStore.profileStore.forgotPassword(
      (component.refs.email as HTMLInputElement).value,
      function(error: boolean, errorType: string, errorMessage: string) {
        console.log(error);
        if (error) {
          let errorState: any = {};
          errorState[errorType] = errorMessage
          component.setState(errorState);
          component.setState({
            loading: false,
          })
        } else {
          component.setState({
            loading: false,
            returnedSuccess: "Password Reset Requested",
          })
        }
      }
    );
  }

  render() {
    var loader;

    var returnedError: JSX.Element = <div></div>;
    var returnedSuccess: JSX.Element = <div></div>;
    if (this.state.returnedError) {
      returnedError = (<div className="alert alert-warning" role="alert">
        <strong>Password Reset Error: </strong> {this.state.returnedError}
      </div>);
    }

    if (this.state.returnedSuccess) {
      returnedSuccess = (<div className="alert alert-success" role="alert">
        <strong>Success: </strong> {this.state.returnedSuccess}
      </div>);
    }


    if (this.state.loading) {
      loader = <img src="/images/ajax-loader.gif" />;
    }

    return (
      <div className="Passport container-fluid">
      <div className="row">
        <div className="fixed-50 back hidden-xs">
          <img src="/images/blue-close-up-colorful-1333318.jpg" className="img-fluid" />
          <div className="fixed-image-caption">Photo by <a className="underlined" target="_blank" href="/https://www.pexels.com/@magda-ehlers-pexels?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels">Magda Ehlers</a> from <a className="underlined" target="_blank" href="/https://www.pexels.com/photo/red-and-multicolored-figure-1333320/?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels">Pexels</a></div>
        </div>
        <div className="fixed-50 fore form-half">
            <h1>Forgot Password</h1>
            <br />
            <form onSubmit={this.doForgotPassword} action="/api/v1/forgot" method="post">
                <div className="form-group">
                    <label>Email</label>
                    <input type="text" className="form-control" name="email" ref="email" />
                    <div className="form-warning text-danger"><b>{this.state.emailError}</b></div>
                </div>
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-lg">Forgot Password</button>
                  <span className="form-warning pull-right">{loader}</span>
                </div>
            </form>
            <div className="form-group">
              {returnedError}
              {returnedSuccess}
            </div>
            <hr />
            <p><Link to="/login">Login</Link></p>
            <p>Or go <Link to="/">home</Link>.</p>
        </div>
        </div>
      </div>
    );
  }
}

export default observer(Forgot);
